import React from "react";
import VideocamRoundedIcon from "@material-ui/icons/VideocamRounded";
import { Avatar, Button, Grid, Tooltip } from "@material-ui/core";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";

export const VideoCallMessage = ({ sender, receiver, chatTemplate, ...rest }) => {
  const { primaryColor, secondaryColor } = chatTemplate;
  return (
    <Grid container justifyContent="space-between" style={{ marginTop: 5 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Avatar style={{ backgroundColor: primaryColor, marginRight: 10 }}>
          <VideocamRoundedIcon style={{ color: secondaryColor }} />
        </Avatar>
        <Button size="small" onClick={() => window.open(`https://meet.jirango.com/${sender + receiver}`, "_blank")} style={{ backgroundColor: primaryColor, color: secondaryColor }}>
          <Tooltip title={<EventLabel2 name="EnterVideoChatGroup" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
            <span>
              <EventLabel2 name="Join" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />
            </span>
          </Tooltip>
        </Button>
      </div>
    </Grid>
  );
};
